import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class EqualHousingLenderSVG extends React.PureComponent {
  render() {
    return (
      <svg width="13px" height="9px" viewBox="0 0 13 9" version="1.1">
        <title>Equal Housing Lender Logo</title>
        <g id="v0-FINAL" stroke="none" strokeWidth="1" fillRule="evenodd" fillOpacity="0.8">
          <g
            id="dark---no-picture-copy-2"
            transform="translate(-165.000000, -851.000000)"
            fillRule="nonzero"
            className={css(styles.login)}
          >
            <g id="equal-housing-lender-1" transform="translate(165.000000, 851.000000)">
              <path
                d="M0,3.44643038 L6.53195327,0 L12.9183551,3.48060759 L12.9183551,4.69196203 L11.8993738,4.69196203 L11.8993738,8.97448101 L1.00075701,8.97448101 L1.00075701,4.69207595 L0,4.69207595 L0,3.44643038 Z M6.53146729,1.29839241 L2.32845794,3.58473418 L2.32845794,7.88434177 L10.6434766,7.88434177 L10.6434766,3.58473418 L6.53146729,1.29839241 Z M4.29607477,5.22273418 L4.29607477,4.16483544 L8.64463551,4.16483544 L8.64463551,5.22273418 L4.29607477,5.22273418 Z M4.29607477,5.75020253 L8.64463551,5.75020253 L8.64463551,6.80810127 L4.29607477,6.80810127 L4.29607477,5.75020253 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
